import type { App as VueApp } from 'vue'
import Notifications from '@kyvg/vue3-notification'
import PortalVue from 'portal-vue'
import Vue3TouchEvents, { type Vue3TouchEventsOptions } from 'vue3-touch-events'
import FloatingVue from 'floating-vue'
import vueChartist from 'vue-chartist'
import VCalendar from 'v-calendar'
import { setupVeeValidate } from '@/config/setup/plugins/veeValidate/index.js'

export default function registerOtherPlugins(app: VueApp) {
  app.use(Notifications)
  app.use(PortalVue)
  app.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
    touchClass: '',
    tapTolerance: 10,
    swipeTolerance: 30,
    longTapTimeInterval: 400,
  })

  app.use(FloatingVue, {
    themes: {
      'notification-center': {
        $extend: 'dropdown',
      },
      'sdui-planner': {
        $extend: 'dropdown',
      },
    },
  })

  app.use(vueChartist)
  app.use(VCalendar, {
    masks: {
      title: 'MMMM YYYY',
      navMonths: 'MMM',
      input: ['DD MMM'],
    },
  })

  // VeeValidate does not require app.use. But we still want to add custom rules etc, that's why it's done here.
  setupVeeValidate()
}
